
import { AutomatedMessage } from "./types";

// Sort messages by send time (convert to minutes first)
export const getSortedMessages = (messages: AutomatedMessage[]) => {
  const convertTimeToMinutes = (timeStr: string) => {
    const str = timeStr.toLowerCase().trim();
    
    // Extract numeric value
    const numericValue = parseInt(str);
    if (isNaN(numericValue)) return 0;
    
    // Handle different formats
    if (str.includes("min")) return numericValue;
    if (str.includes("h") || str.includes("hour")) return numericValue * 60;
    if (str.includes("d") || str.includes("dia")) return numericValue * 24 * 60;
    if (str.includes("semana")) return numericValue * 7 * 24 * 60;
    if (str.includes("mes") || str.includes("mês")) return numericValue * 30 * 24 * 60;
    
    // For plain numbers without units, assume minutes if <= 60, otherwise assume days
    if (numericValue <= 60) return numericValue;
    return numericValue * 24 * 60;
  };

  return [...messages].sort((a, b) => 
    convertTimeToMinutes(a.sendTime) - convertTimeToMinutes(b.sendTime)
  );
};

export const getFormattedSendTime = (sendTime: string) => {
  const str = sendTime.toLowerCase().trim();
  const numericValue = parseInt(str);
  
  if (isNaN(numericValue)) return `${sendTime} após a indicação`;
  
  // Standardize format based on time unit
  if (str.includes("min")) {
    return `${numericValue}min após a indicação`;
  }
  
  if (str.includes("h") || str.includes("hour")) {
    return `${numericValue}h após a indicação`;
  }
  
  if (str.includes("d") || str.includes("dia")) {
    return numericValue === 1 ? "1 dia após a indicação" : `${numericValue} dias após a indicação`;
  }
  
  if (str.includes("semana")) {
    return numericValue === 1 ? "1 semana após a indicação" : `${numericValue} semanas após a indicação`;
  }
  
  if (str.includes("mes") || str.includes("mês")) {
    return numericValue === 1 ? "1 mês após a indicação" : `${numericValue} meses após a indicação`;
  }
  
  // For plain numbers, apply logic based on value
  if (numericValue <= 60) {
    return `${numericValue}min após a indicação`;
  } else {
    return numericValue === 1 ? "1 dia após a indicação" : `${numericValue} dias após a indicação`;
  }
};
